import {useAppContext} from '../components/app/AppContext';
import {json, JsonMappers} from '../core/data-source/json.mapper';
import {DictionaryRecord} from './dictionary.record';
import {LanguageRecord} from './language.record';

export enum Role {
    ADMIN = 'admin',
    DISPATCHER = 'dispatcher',
    DRIVER = 'performer',
    CUSTOMER_SERVICE = 'customer_service'
}

class UserAccountRecord {
    @json()
    globalId: string;

    @json()
    name: string;

    @json({
        jsonName: 'created'
    })
    createdAt?: number;

    @json()
    url: string;

    @json()
    id: number;
}

export class UserRecord {
    @json()
    id: number;

    @json()
    globalId: string;

    @json()
    externalID: string;

    @json()
    name: string;

    @json()
    login: string;

    @json({
        mapper: JsonMappers.InstanceOf(() => UserAccountRecord)
    })
    account: UserAccountRecord;

    @json({
        value: {
            [Role.ADMIN]: false,
            [Role.CUSTOMER_SERVICE]: false,
            [Role.DISPATCHER]: false,
            [Role.DRIVER]: false
        }
    })
    roles: {[key: string]: boolean};

    @json()
    hasAPIAccess: boolean;

    @json()
    email: string;

    @json({
        jsonName: 'password_new'
    })
    passwordNew: string;

    @json({
        jsonName: 'password_new_confirm'
    })
    passwordNewConfirm: string;

    @json({
        jsonName: 'cs_aoc',
        mapper: JsonMappers.ArrayOf(() => DictionaryRecord)
    })
    csAoc: DictionaryRecord[];

    @json({
        jsonName: 'dispatcher_aoc',
        mapper: JsonMappers.ArrayOf(() => DictionaryRecord)
    })
    dispatcherAoc: DictionaryRecord[];

    @json({
        jsonName: 'performer_aoc',
        mapper: JsonMappers.ArrayOf(() => DictionaryRecord)
    })
    performerAoc: DictionaryRecord[];

    @json(JsonMappers.InstanceOf(() => LanguageRecord))
    language: LanguageRecord;

    @json()
    evoUserId: string;

    @json()
    sessionId: string;

    @json()
    currentRole: Role;

    @json({
        jsonName: 'timezone',
        mapper: {
            from: (data: any): number => {
                return data && data.offset ? parseInt(data.offset, 10) : 0;
            }
        }
    })
    timezoneOffset: number;

    @json()
    timezone: any;

    @json({
        jsonName: 'currentRole',
        mapper: {
            from: (value: any) => value == Role.ADMIN
        }
    })
    isAdmin: boolean;

    @json({
        jsonName: 'currentRole',
        mapper: {
            from: (value: any) => value == 'dispatcher'
        }
    })
    isDispatcher: boolean;

    canEditSettings(): boolean {
        const userRole: string = this.currentRole;
        return (
            userRole === Role.ADMIN ||
            (userRole == Role.DISPATCHER && useAppContext().settings.dispatcherCanEditSettings)
        );
    }
}
